// extracted by mini-css-extract-plugin
export default {"container":"AddressInfo_container__KV9La","title":"AddressInfo_title__JFjSY","content":"AddressInfo_content__E7uqt","tel":"AddressInfo_tel__ON7mB"};